import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

  let project = props.project
  let title  = project.title
  let excerpt  = project.excerpt
  let short_excerpt = excerpt.substring(0, 110) + '...'
  let link  = project.url
  let raw_date = project.date
  let date = Moment(raw_date).format('DD/MM/YYYY')
  let feat_image = project.feat_image
  let company = project.company

  if (props.language == 'en') {
    date = Moment(raw_date).format('MM/DD/YYYY')
  }

  let companyLogo = {
      'Installatie Techniek': '/themes/barthgroep/img/logo-it_h.svg',
      'Industrial Automation': '/themes/barthgroep/img/logo-ia_h.svg',
      'Aldonk': '/themes/barthgroep/img/logo-aldonk_h.svg',
      'Controlscope': '/themes/barthgroep/img/logo-controlscope_h.svg',
      'Engin': '/themes/barthgroep/img/logo-engin_h.svg',
      'Barth Groep': '/themes/barthgroep/img/logo-groep_h.svg',
  };

  return (
    <div className="c-recent-project u-flex">

      <div className="c-recent-project__image-container">
        <a href={link} target="_blank">
          <div dangerouslySetInnerHTML={{ __html: feat_image }} />
        </a>
      </div>

      <div className="c-recent-project__content-container">
        <a
          href={link}
          target="_blank"
          className="c-recent-project__link"
        >
            <span className="c-recent-project__branch c-recent-project__date">{date}</span>
            <h4 className="c-recent-project__title" dangerouslySetInnerHTML={{ __html: title }} />

          <p className="c-recent-project__excerpt" dangerouslySetInnerHTML={{ __html: short_excerpt }} />

          <div className="c-recent-project__footer u-flex u-flex-sb">
            <div class="c-recent-project__branches">
              <img class="c-recent-project__branch__logo" alt={ company } src={typeof companyLogo[company] !== 'undefined' ? companyLogo[company] : null } />
            </div>

            <div className="c-recent-project__icon-container">
              <svg class="c-icon c-recent-project__icon">
                <use href="#arrow-thin-right" xlinkHref="#arrow-thin-right"></use>
              </svg>
            </div>
          </div>

        </a>
      </div>

    </div>
  )
}

export default Project



// WEBPACK FOOTER //
// ./src/js/recent-news/components/Project.js
